import React from 'react'
import PropTypes from 'prop-types'
import { Box, Switch, Tooltip } from '@material-ui/core'
import { Info as InfoIcon } from 'react-feather'

import { scopeColorShape } from '../../propTypes'
import styles from './styles'

const PermissionMatrixCell = ({
  color,
  width,
  checked,
  disabled,
  disabledHint,
  onChange,
}) => {
  const useStyles = styles(color, width)
  const classes = useStyles()

  if (disabled) {
    return (
      <Box className={classes.cell}>
        <Switch checked={false} disabled />
        <Tooltip title={disabledHint || ''} arrow>
          <Box className={classes.info}>
            <InfoIcon size={16} />
          </Box>
        </Tooltip>
      </Box>
    )
  }

  return (
    <Box className={classes.cell}>
      <Switch
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        classes={{
          switchBase: classes.switchBase,
          checked: classes.checked,
          track: classes.track,
        }}
      />
    </Box>
  )
}

PermissionMatrixCell.propTypes = {
  color: scopeColorShape.isRequired,
  width: PropTypes.number,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledHint: PropTypes.string,
  onChange: PropTypes.func,
}

export default PermissionMatrixCell
